import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Input, Card, WarningText } from 'components';
import { useResetPasswordMutation } from 'redux/slices/signUp/SignUpApi';
import { apiResHandler } from 'utils/axiosBaseQuery';
import { REGEX_SPECIAL, REGEX_DIGIT, REGEX_CASE } from 'constant/Validation';
import { useDispatch } from 'react-redux';
import { addAlertQueue } from 'redux/slices/snackbar/snackbarSlice';

const ResetPasswordContent = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const [formData, setFormData] = useState({
    code: code,
    password1: '',
    password2: '',
  });

  const [pwRegex, setPwRegex] = useState({
    special: '',
    min: 'a',
    case: '',
    digit: '',
    equal: '',
  });

  const handleInputOnChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handlePasswordRegex = (pw1, pw2) => {
    setPwRegex({
      ...pwRegex,
      digit: REGEX_DIGIT.test(pw1) ? 'success' : 'error',
      special: REGEX_SPECIAL.test(pw1) ? 'success' : 'error',
      case: REGEX_CASE.test(pw1) ? 'success' : 'error',
      min: pw1.length > 7 ? 'success' : 'error',
      equal: pw1 === pw2 ? 'success' : 'error',
    });
  };

  const handleSubmit = () => {
    if (
      pwRegex.min === 'success' &&
      pwRegex.case === 'success' &&
      pwRegex.digit === 'success' &&
      pwRegex.special === 'success' &&
      pwRegex.equal === 'success'
    ) {
      apiResHandler(
        resetPassword({ data: formData }),
        () => {
          dispatch(
            addAlertQueue({
              message: 'Şifre başarıyla değiştirildi!',
              status: 'success',
              show: true,
              duration: 5000,
            })
          );
          setTimeout(() => {
            navigate('/');
          }, 1000);
        },
        ({ message }) => {
          dispatch(
            addAlertQueue({
              message: message,
              status: 'error',
              show: true,
              duration: 5000,
            })
          );
        }
      );
    } else {
      dispatch(
        addAlertQueue({
          message: 'Şifre tüm doğrulamalardan geçmedi!',
          status: 'error',
          show: true,
          duration: 5000,
        })
      );
    }
  };

  useEffect(() => {
    if (formData.password1 && formData.password2) {
      handlePasswordRegex(formData.password1, formData.password2);
    }
  }, [formData.password1, formData.password2]);

  return (
    <Card className="flex flex-col mx-auto bg-white w-full h-70vh sm:w-96  p-0 border-none">
      <form className="flex flex-col gap-y-4 items-center justify-center h-2/3">
        <Input
          maxLength={64}
          isTextVisible={false}
          required
          label="Yeni Şifre"
          name="password1"
          id="password1"
          type="password"
          value={formData.password1}
          onChange={(e) => handleInputOnChange(e.target.name, e.target.value)}
        />
        <Input
          maxLength={64}
          isTextVisible={false}
          required
          label="Yeni Şifreni Onayla"
          name="password2"
          id="password2"
          type="password"
          value={formData.password2}
          onChange={(e) => handleInputOnChange(e.target.name, e.target.value)}
        />
        <div className="">
          <WarningText
            text="En az 8(sekiz) karakterli olmalıdır."
            textType={pwRegex.min}
          />
          <WarningText
            text="İçerisinde en az 1(bir) tane büyük ve en az 1(bir) tane küçük harf bulunmalıdır. "
            textType={pwRegex.case}
          />
          <WarningText
            text="İçerisinde en az 1(bir) tane rakam bulunmalıdır."
            textType={pwRegex.digit}
          />
          <WarningText
            text="İçerisinde en az 1(bir) tane özel karakter bulunmalıdır. (@, !,?,A,+,$,#,&,/,{,*,-,],=,...)"
            textType={pwRegex.special}
          />
          <WarningText
            text="Şifreler birbirine eşit olmalıdır."
            textType={pwRegex.equal}
          />
        </div>

        <div className="flex gap-x-2 w-full">
          <Button
            text="Geri Dön"
            className="bg-red p-3"
            textVariant="white"
            onClick={() => navigate(-1)}
          />
          <Button
            text="Gönder"
            className="bg-primary p-3"
            textVariant="white"
            disabled={
              isLoading ||
              !(
                pwRegex.min === 'success' &&
                pwRegex.case === 'success' &&
                pwRegex.digit === 'success' &&
                pwRegex.special === 'success' &&
                pwRegex.equal === 'success'
              )
            }
            onClick={handleSubmit}
          />
        </div>
      </form>
    </Card>
  );
};

export default ResetPasswordContent;
